import styled, { CSSProp } from 'styled-components';
import { Headers } from '../TextSubHeaders';
import { Paragraph } from '../Paragraph';

export const BodyWrapper = styled.div`
  max-width: 525px;
  margin: 0 auto;
  margin-top: 24px;
  text-align: center;
    @media screen and (min-width: 1440px) {
      margin-top: 80px;
    }
`;

export const BodyParagraph = styled(Paragraph)`
  @media screen and (min-width: 1440px) {
    font-size: 26px;
  }
  font-size: 18px;
  color: #fff;
`;

export const BodyHeader = styled(Headers)`
  margin-top: 0;
  font-size: 35px;
  letter-spacing: 0.06em;
  @media screen and (min-width: 1440px) {
    font-size: 60px;
  }
  color: #fff;
`;

export const SubPageHeader = styled(Headers)`
  text-align: center;
  margin-top: 0;
  font-size: 35px;
  letter-spacing: 0.06em;
    @media screen and (min-width: 1440px) {
      font-size: 60px;
    }
  color: #fff;
`;

export const SubPageBanner = styled.section`
  position: relative;
  padding-bottom: 20px;
  padding-top: 9px;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
`;

export const SubPageBannerImage = styled.div`
  z-index: -1;
  top: 0;
  position: absolute;
  background: linear-gradient(90.12deg, rgba(0, 0, 0, 0) 14.57%, 
  rgba(0, 0, 0, 0.2) 49.35%, 
  rgba(0, 0, 0, 0) 87.49%), 
  ${({ image }: { image: string }): CSSProp => `url(${image})`},
  #C4C4C4;
  min-height: 100vh;
  width: 100%;
  background-position: center;
  background-size: cover;
`;

export const SectionButtonsWrapper = styled.div`
  margin-top: 56px;
  @media screen and (max-width: 1200px) {
    display: grid;
    a {
      margin-bottom: 10px;
    }
  }
`;
